<script>
import ZoomedImage from "@/components/organisms/zoomed-image";
import Button from "@/components/atoms/button";
import Carousel from "@/components/organisms/carousel";
import CarouselSlide from "@/components/organisms/carousel/carousel-slide";
import LazyImage from "@/components/atoms/lazy-image/index";
import Icon from "@/components/atoms/icon/index";
import Popin from "@/components/molecules/popin/index";
import { imageProductViewerProps, useImageProductViewer } from "./mixin";
export default {
  name: "ImageProductViewer",
  components: {
    ZoomedImage,
    Icon,
    Carousel,
    CarouselSlide,
    LazyImage,
    Button,
    Popin
  },
  props: {
    ...imageProductViewerProps()
  },
  setup(props, context) {
    const { showModal, principalImage, handleClick } = useImageProductViewer(
      props,
      context
    );
    return {
      showModal,
      principalImage,
      handleClick
    };
  },
  methods: {
    toggleImageZoomer() {
      this.showModal = !this.showModal;
    }
  }
};
</script>

<template>
  <div class="c-image-product-viewer-mobile">
    <Popin
      ref="operationInfos"
      :slide-up="true"
    >
      <p class="u-text-left">
        {{ pictoPrincipal.code === 'moins_cher' ? 'Sélection coradrive : le moins cher' : pictoPrincipal.alt }}
      </p>
    </Popin>
    <div
      class="c-image-product-viewer-mobile__images-container"
      @click="toggleImageZoomer"
    >
      <div
        v-if="pictoPrincipal"
        class="c-image-product-viewer-mobile__ope-sticker"
      >
        <Button @click="(e) => { e.stopPropagation(); $refs.operationInfos.show()}">
          <LazyImage
            height="60"
            width="60"
            :src="pictoPrincipal.url"
            :alt="pictoPrincipal.code === 'moins_cher' ? 'Sélection coradrive : le moins cher' : pictoPrincipal.alt"
            class="c-image-product-viewer-mobile__ope-sticker-img"
            dimension="84"
          />
        </Button>
      </div>
      <Icon
        name="zoom"
        variant="white"
        class="c-image-product-viewer-mobile__image-icon-zoom"
        size="lg"
      />
      <ClientOnly>
        <Carousel
          :elements-per-slide="1"
          :bullets="true"
          :navigation-arrows="images.length > 1"
          class="c-image-product-viewer-mobile__images-carousel"
        >
          <CarouselSlide
            v-for="(image, index) in images"
            :key="`slide-${index}`"
            class="c-image-product-viewer-mobile__image-slide"
          >
            <Button
              class="c-image-product-viewer-mobile__image-button"
              @click="handleClick(image)"
            >
              <div
                v-if="image.type=='video'"
                class="c-image-product-viewer-mobile__image-slide-video-overlay"
              >
                <Icon
                  name="play"
                  variant="white"
                  size="xxlg"
                  class="c-image-product-viewer-mobile__image-slide-video-overlay-icon"
                />
                <span class="c-image-product-viewer-mobile__image-slide-video-overlay-text">Video</span>
              </div>
              <LazyImage
                :src="image.type === 'video' ? principalImage.url : image.url"
                dimension="600"
                height="70"
                width="70"
                :alt="productName"
                loading="eager"
                class="c-image-product-viewer-mobile__image"
              />
              <!-- :srcset="getPrincipalImageSrcset(image.type === 'video' ? principalImage.url : image.url)" -->
            </Button>
          </CarouselSlide>
        </Carousel>
        <template #fallback>
          <LazyImage
            :src="principalImage.url"
            dimension="600"
            height="70"
            width="70"
            :alt="productName"
            loading="eager"
            class="c-image-product-viewer-mobile__image c-image-product-viewer-mobile__image-fallback"
          />
        </template>
      </ClientOnly>
    </div>
    <ZoomedImage
      v-if="showModal"
      :default-principal-img="principalImage"
      :images="images"
      :enable-tap-to-zoom="false"
      @closed="toggleImageZoomer"
    />
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/image-product-viewer-mobile";
</style>
